import { Expose, Transform } from 'class-transformer'
import { PromotionBuyAllEnum } from '@interfaces/PromotionTypeEnum'
import { EbookSalesStatusEnum } from '@interfaces/EbookSalesStatusEnum'

export class SalesAnalyticsDataEbookTableType {
  @Expose() discountedPrice: number

  @Expose() ebookTitle: string

  @Expose() promotionDiscountValue: number

  @Expose() promotionEndedAt: string

  @Expose()
  @Transform(({ value }) =>
    value
      ? (value.toUpperCase() as PromotionBuyAllEnum)
      : PromotionBuyAllEnum.PERCENTAGE
  )
  promotionType: PromotionBuyAllEnum

  @Expose()
  @Transform(({ obj }) => obj.rawPrice - obj.discountedPrice)
  discountCoinValue: number

  @Expose()
  @Transform(({ obj }) =>
    obj.promotionType === 'percentage'
      ? obj.promotionDiscountValue
      : Math.round((obj.promotionDiscountValue / obj.rawPrice) * 100)
  )
  discountPercentValue: number

  @Expose() promotionStartedAt: string

  @Expose() rawPrice: number

  @Expose() total: number

  @Expose() promotionStatus: EbookSalesStatusEnum

  @Expose() penName: string

  @Expose() coverImgPath: string

  @Expose() category: string
}
